<script setup lang="ts">
import { ref, watch, computed } from "vue";
import {
    CommonAlert,
    CommonModal,
    CommonModalSecondLayer,
} from "@/shared/components/temparary/components";
import { useRoute } from "vue-router";
import { VueQueryDevtools } from "@tanstack/vue-query-devtools";

// features
import RootErrorBoundary from "@/features/common/catch-error/ui/RootErrorBoundary.vue";
import ServiceEndNoticeModal from "@/shared/components/popup/ServiceEndNoticeModal.vue";

const route = useRoute();
const transitionEffectName = ref("fade");
const exceptionRoute = ["challenge-up"];

// route 이동이 base route 일 때만 transition 효과가 적용되도록 설정
watch(
    () => route.path,
    (from, to) => {
        const beforeRouteBase = from.split("/")[1];
        const afterRouteBase = to.split("/")[1];

        /**
         * @description
         * path 가 동일하다면 (query 나 root path 말고) 기본적으로 none 입니다.
         * 단, exceptionRoute 에 포함되어 있다면 fade 로 설정합니다. (속해있는 라우트는 화면 전환 효과가 필요하다 판단됩니다.)
         */
        beforeRouteBase === afterRouteBase
            ? exceptionRoute.includes(beforeRouteBase)
                ? (transitionEffectName.value = "fade")
                : (transitionEffectName.value = "none")
            : (transitionEffectName.value = "fade");
    },
);
</script>

<template>
    <section class="flex items-center justify-center w-[145rem] xl:w-full">
        <section class="xl:w-full w-[160rem] h-full">
            <component :is="route.meta.layout">
                <router-view v-slot="{ Component }">
                    <transition :name="transitionEffectName" mode="out-in">
                        <RootErrorBoundary>
                            <component :is="Component"></component>
                        </RootErrorBoundary>
                    </transition>
                </router-view>
            </component>
            <CommonAlert />
            <CommonModal />
            <CommonModalSecondLayer />
            <PopupAnchor />
            <ServiceEndNoticeModal />
        </section>
        <VueQueryDevtools />
    </section>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.none-enter-active,
.none-leave-active {
    transition: none;
}

.none-enter-from,
.none-leave-to {
    opacity: 100;
}
</style>
